module.exports = __webpack_public_path__ + "static/media/NavReportBug.812fd4a3.svg";